import SelectR from "./SelectR";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default SelectR;
